export const APP_CONSTANTS_API = {
  X_API_Key: 'SkyWard-secret-key-change-in-production-2026awGwdawaAshgkutDRJFFB',
  BASE_URL: '/api',
  STATEMENT: '/statement',
  EMPLOYEESS: '/employees',
  BOOKINGSEESSIONS: '/sessions',
  SESSIONSREQUESTS: '/sessions/requests',
  PROMOTIONS: '/promotions',
  PROJECTS: '/projects',
  SERVICES: '/services',
  ADDRES: '/addresses',
  REVIEW: '/review',
  REVIEWREQUEST: '/review-request',
  VISITANALUTICS: '/visit-analytics',
  FAQ: '/faq',
};
